import axios from '@/utils/api.request'
// import axios from 'axios'
let previousUrl = '/api'
// 发起案件 保存草稿
export default (data) => {
  return axios.request({
    url: `${previousUrl}/cases/draft`,
    data: data,
    method: 'post'
  })
}
// 获取新增或修改案件所需默认的数据
export const getDefaultData = (id) => {
  return axios.request({
    url: `${previousUrl}/cases/${id}`,
    method: 'get'
  })
}
// 更新修改保存的案件
export const updateCase = (id, data) => {
  return axios.request({
    url: `${previousUrl}/cases/tempsave`,
    data: data,
    method: 'patch'
  })
}
// 案件提交
export const submitCase = (data) => {
  return axios.request({
    url: `${previousUrl}/cases/submit`,
    data: data,
    method: 'post'
  })
}
// 获取各个状态下的案件数量
export const getCountList = () => {
  return axios.request({
    url: `${previousUrl}/cases/countList`,
    method: 'get'
  })
}
// 草稿案件获取
export const getDraftCaseData = (pageNumber, pageSize, fromData) => {
  return axios.request({
    url: `${previousUrl}/cases/listStatus0?page=${pageNumber}&size=${pageSize}`,
    method: 'post',
    data: fromData
  })
}
// 未处理案件获取
export const getUntreatedCaseData = (pageNumber, pageSize, fromData) => {
  return axios.request({
    url: `${previousUrl}/cases/listStatus1?page=${pageNumber}&size=${pageSize}`,
    method: 'post',
    data: fromData
  })
}
// 处理中案件获取
export const getHandlingCaseData = (pageNumber, pageSize, fromData) => {
  return axios.request({
    url: `${previousUrl}/cases/listStatus2?page=${pageNumber}&size=${pageSize}&sort=Id,desc`,
    data: fromData,
    method: 'post'
  })
}

// 预警案件获取
export const getAlarmCaseData = (pageNumber, pageSize, fromData) => {
  return axios.request({
    url: `${previousUrl}/AlarmInfo/list?page=${pageNumber}&size=${pageSize}`,
    method: 'post',
    data: fromData
  })
}
export const getAlarmCaseInfo = (id) => {
  return axios.request({
    url: `${previousUrl}/AlarmInfo/${id}`,
    method: 'get'
  })
}

// 预警数量
export const getAlarmCaseCount = (data) => {
  return axios.request({
    url: `${previousUrl}/AlarmInfo/list`,
    method: 'post',
    data: data
  })
}
// 结案案件获取
export const getClosingCaseData = (pageNumber, pageSize, fromData) => {
  return axios.request({
    url: `${previousUrl}/cases/listStatus3?page=${pageNumber}&size=${pageSize}`,
    method: 'post',
    data: fromData
  })
}
// 草稿案件查询
export const searchDraftCaseData = (data) => {
  return axios.request({
    url: `${previousUrl}/cases/listStatus0`,
    data: data,
    method: 'post'
  })
}
// 草稿案件删除
export const delete0 = (data) => {
  return axios.request({
    url: `${previousUrl}/cases/delete/${data}`,
    method: 'delete'
  })
}
// 未处理案件查询
export const searchUntreatedCaseData = (data) => {
  return axios.request({
    url: `${previousUrl}/cases/listStatus1`,
    data: data,
    method: 'post'
  })
}
// 处理中案件查询
export const searchHandlingCaseData = (data) => {
  return axios.request({
    url: `${previousUrl}/cases/listStatus2`,
    data: data,
    method: 'post'
  })
}
// 结案案件查询
export const searchClosingCaseData = (data) => {
  return axios.request({
    url: `${previousUrl}/cases/listStatus3`,
    data: data,
    method: 'post'
  })
}
// 查询案件
export const searchCaseDetail = (id) => {
  return axios.request({
    url: `${previousUrl}/cases/${id}`,
    method: 'get'
  })
}
// tmci提交
export const tmciSubmit = (data) => {
  return axios.request({
    data: data,
    url: `${previousUrl}/cases/tmciSubmit`,
    method: 'post'
  })
}
// 切换用户级别
export const switchLevel = (level) => {
  return axios.request({
    url: `${previousUrl}/user/switchLevel/${level}`,
    method: 'get'
  })
}
// 结案
export const doneSubmit = (data) => {
  return axios.request({
    data: data,
    url: `${previousUrl}/cases/done`,
    method: 'post'
  })
}
// 获得img
export const getImg = (img) => {
  return axios.request({
    url: `${previousUrl}/${img}`,
    method: 'get',
    responseType: 'arraybuffer'
  })
}
// 获得video
export const getVideo = (img) => {
  return axios.request({
    url: `${previousUrl}/${img}`,
    method: 'get',
    responseType: 'blob'
  })
}
// 聊天列表
export const newsChatALLData = (level) => {
  return axios.request({
    url: `${previousUrl}/reply/${level}`,
    method: 'get'
  })
}
// 发送消息
export const sendOutNewsInfo = (data) => {
  return axios.request({
    data: data,
    url: `${previousUrl}/reply/add`,
    method: 'post'
  })
}
// 根据vin返回车辆信息
export const searchVin = (vin) => {
  return axios.request({
    url: `${previousUrl}/vin/${vin}`,
    method: 'get'
  })
}
// 信息列表
export const getReplyList = (id, keyword) => {
  return axios.request({
    url: `${previousUrl}/reply/${id}?keyword=${keyword}`,
    method: 'get'
  })
}
// 再次发起案件
export const renewCase = (id, oldId) => {
  return axios.request({
    url: `${previousUrl}/cases/renew/${id}`,
    method: 'get'
  })
}
// 退回
export const dlrReturn = (id) => {
  return axios.request({
    url: `${previousUrl}/cases/dlrReturn/${id}`,
    method: 'get'
  })
}
// 获取区域id和名称
export const getAreaList = (id) => {
  return axios.request({
    url: `${previousUrl}/areaByUser`,
    method: 'get'
  })
}

// 切换用户级别
export const switchLevels = (level) => {
  return axios.request({
    url: `${previousUrl}/user/switchLevel/${level}`,
    method: 'get'
  })
}
export const switchLevels1 = (level, field) => {
  return axios.request({
    url: `${previousUrl}/user/switchLevel/${level}/${field}`,
    method: 'get'
  })
}
export const countUnread = () => {
  return axios.request({
    url: `${previousUrl}/message/countUnread`,
    method: 'get'
  })
}

export const getFavour = (pageNumber, pageSize, data) => {
  return axios.request({
    url: `${previousUrl}/cases/favours?page=${pageNumber}&size=${pageSize}&sort=Id,desc`,
    method: 'post',
    data: data
  })
}

// 收藏取消收藏
export const caseFavour = (id) => {
  return axios.request({
    url: `${previousUrl}/favour/${id}`,
    method: 'get'
  })
}

// 提交交车时间
export const commitDelivery = (id, time = '') => {
  return axios.request({
    url: `${previousUrl}/cases/delivery/${id}/${time}`,
    method: 'get'
  })
}

// 好事例案件获取
export const getNiceCaseData = (pageNumber, pageSize, fromData) => {
  return axios.request({
    url: `${previousUrl}/Example/list?page=${pageNumber}&size=${pageSize}`,
    method: 'post',
    data: fromData
  })
}
